// extracted by mini-css-extract-plugin
export default {"publication-image":"publication-image","publicationImage":"publication-image"};